import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { debounceTime, switchMap, map, first } from 'rxjs/operators';
import { EventPersonalization, Organizer } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AdminOrganizerService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  public getMoreOrganizers = new Subject<{limit: number, offset: number, searchQuery: string}>();

  exportFilteredOrganizers(filters): Observable<ArrayBuffer> {
    const route = `${this.configUrl}exploreOrganizers`;
    const params = new HttpParams({
      fromObject: {
        format: 'csv',
        searchQuery: filters.searchQuery ? encodeURIComponent(filters.searchQuery.toString()) : '',
      },
    });
    return this.http.get(route, {params, responseType: 'arraybuffer'}).pipe(
      map((file: ArrayBuffer) => file),
    );
  }

  getOrganizerList(): Observable<{rows: Organizer[], count: number}> {
    const route = `${this.configUrl}exploreOrganizers`;
    return this.getMoreOrganizers.pipe(
      // wait 300ms after each keystroke before considering the term
      debounceTime(600),
      // switch to new search observable each time the term changes
      switchMap( ({limit, offset, searchQuery}) => {
        const params = new HttpParams({
          fromObject: {
            limit: limit.toString(),
            offset: offset.toString(),
            searchQuery: encodeURIComponent(searchQuery.toString()),
          },
        });
        return this.http.get<{rows: Organizer[], count: number}>(route, {params});
      }),
    );
  }

  searchOrganizer(searchTerm: string): Observable<Organizer[]> {
    const route = `${this.configUrl}exploreOrganizers`;
    const params = new HttpParams({
      fromObject: {
        limit: '5',
        offset: '0',
        searchQuery: encodeURIComponent(searchTerm.toString()),
      },
    });
    return this.http.get<{rows: Organizer[], count: number}>(route, {params}).pipe(
      map((res) => res.rows.map((o) => new Organizer(o))),
    );
  }

  createOrganizer(organizer: Organizer) {
    const route = `${this.configUrl}organizer`;

    return this.http.post(route, organizer).pipe(
      first(),
    );
  }

  removeUserFromOrga(userId: number) {
    const route = `${this.configUrl}o/removeUser`;
    return this.http.post(route, {userId}).pipe(
      first(),
    );
  }

}
